var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"btn-lg btn-dark text-white btn ml-0 mr-2 ",on:{"click":function($event){return _vm.toggleFileSettings();}}},[_c('i',{staticClass:"fas fa-share-alt"})])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98f7c6ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ShareFileButton.vue
// module id = JnxP
// module chunks = 0